import React, { FC } from 'react'

import { MainLayoutProps } from '../../layouts'
import { ActionButtonProps } from '../../components/ActionButton'
import { AdsSortingFiltersProps } from '../../components/AdsSortingFilters'
import AdsTableItem, { AdsTableItemProps } from '../../components/AdsTableItem'
import { BannerTitleTextButtonProps } from '../../components/BannerTitleTextButton'
import { AdsGridProps } from '../../components/AdsGrid'
import SectionWrapper from '../../components/SectionWrapper'
import { PaginationProps } from '../../components/Pagination'
import { MapProps } from '../../components/Map'

import * as SC from './styled'

export type SearchTemplateProps = MainLayoutProps & {
  sortingFilters?: AdsSortingFiltersProps
  adsList?: Array<AdsTableItemProps>
  adsGrid?: AdsGridProps
  map?: MapProps
  seeMoreButton?: ActionButtonProps
  pagination?: PaginationProps
  infoBanner?: BannerTitleTextButtonProps
  slotModals?: React.ReactNode
  error?: string
}

const SearchTemplate: FC<SearchTemplateProps> = ({
  sortingFilters,
  adsList,
  adsGrid,
  map,
  infoBanner,
  pagination,
  slotModals,
  error,
  ...layout
}) => {
  return (
    <SC.Layout {...layout}>
      {sortingFilters && (
        <SectionWrapper>
          <SC.FiltersBanner {...sortingFilters} />
        </SectionWrapper>
      )}
      {error && <SC.Error>{error}</SC.Error>}
      {adsList && (
        <SectionWrapper>
          <SC.Overflow>
            <SC.Overflow>
              <SC.List>
                {adsList.map((item, index) => (
                  <AdsTableItem key={index} {...item} />
                ))}
              </SC.List>
            </SC.Overflow>
          </SC.Overflow>
        </SectionWrapper>
      )}
      {adsGrid && (
        <SectionWrapper>
          <SC.GridAds {...adsGrid} />
        </SectionWrapper>
      )}
      {map && (
        <SectionWrapper>
          <SC.MapWrapper>
            <SC.MapAds {...map} />
          </SC.MapWrapper>
        </SectionWrapper>
      )}
      {pagination && (
        <SC.Centered spacing={'small'}>
          <SC.PaginationStyled {...pagination} />
        </SC.Centered>
      )}
      {infoBanner && <SC.InfoBanner {...infoBanner} />}
      {slotModals}
    </SC.Layout>
  )
}

export default SearchTemplate
